export default __webpack_public_path__ + "static/media/litho-demo-blog-post-layout-02.5559761c.jpg";